/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class PhotoLayer extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(new THREE.Object3D());
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const view:THREE.Object3D = this.getView();

			const assetLoader:AssetLoader = AssetLoader.getInstance();
			this.dataList = assetLoader.getActivity().getPhotos();
			this.zoomLevel = assetLoader.getMeta().getZoomLevel();

			this.pins = [];
			const pinCount:number = this.dataList.length;
			for (let i:number = 0; i < pinCount; ++i) {
				const data:ActivityPhoto = this.dataList[i];
				if (data.getHasCoordinate()) {
					const pin:PhotoPin = new PhotoPin(data, this.zoomLevel);
					view.add(pin.getView());
					this.pins.push(pin);
				}
			}

			return view;
		}

		protected implReady():void {
			const pinCount:number = this.pins.length;
			for (let i:number = 0; i < pinCount; ++i) {
				const pin:PhotoPin = this.pins[i];
				pin.ready();
				pin.show();
			}
		}

		protected implFinalize():void {
			const pinCount:number = this.pins.length;
			for (let i:number = 0; i < pinCount; ++i) {
				this.pins[i].finalize();
			}
			this.pins = null;

			this.dataList = null;
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = true;
			});
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = false;
			});
		}

		public update():void {
			const pinCount:number = this.pins.length;
			for (let i:number = 0; i < pinCount; ++i) {
				this.pins[i].update();
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private dataList:ActivityPhoto[];
		private zoomLevel:number;

		private pins:PhotoPin[];
	}
}
